<template>
    <v-text-field
        outlined
        hide-details
        v-bind="$attrs"
        v-on="$listeners"/>
</template>

<script>
export default {
    name: 'TextField'
}
</script>

<style lang="scss" scoped>
</style>
